<div [id]="'collapse-'+id" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading-'+id">
	<div class="accordion-body">
		<ng-content></ng-content>
	</div>
</div>
